module.exports = function(){





    /*------------------------------------*\
        setup
    \*------------------------------------*/
    var checkout = require('./checkout-functions.js');
    var pageEl = $('[js-checkout-page-container]');

    window.checkoutFunctions = checkout;




    /*------------------------------------*\
        shipping address and calculate
         validation error
    \*------------------------------------*/
    window.calculateErrors = false;
    window.homeAddressErrorsFromCheckout = false;



    /*------------------------------------*\
        When user enters checkout page
    \*------------------------------------*/
    if ($('[js-checkout-page]').length) {

        checkout.stickySummary();

        Cookies.remove('CHECKOUT_SHIPPING_METHOD');
        Cookies.remove('CHECKOUT_PROMO_CODE');
        Cookies.remove('CHECKOUT_RSREFCODE');
        Cookies.remove('CHECKOUT_SELECTED_MEASUREMENT_PROFILE');

        $('[js-cart-subtotal]').text(' loading...');
        $('[js-cart-subtotal-before-taxes]').text(' loading...');
        $('[js-cart-hst]').text(' loading...');
        $('[js-cart-gst]').text(' loading...');
        $('[js-cart-pst]').text(' loading...');
        //$('[js-cart-total]').text(' loading...');
        $('[js-cart-shipping]').text(' loading...');
        $('[js-cart-total]').text(' loading...');
        $('[js-cart-discount]').text(' loading...');
        //$('[js-cart-rsrefcode]').text(' loading...');

        checkout.addLocalProductsToBackendCart(() => {

            window.addedLocalProductsToBackendCart = true

            checkout.calculate('enters checkout page');

            // check checkout checklist and enable/disable 'complete order' button
            checkout.checkChecklistAndButton();
        })

    }




    /*--------------------------------------------------------*\
        Measurement Profile Select
    \*--------------------------------------------------------*/
    if ( $('.js-checkout-measurement-profile.selectized').length ) {

        Cookies.set('CHECKOUT_SELECTED_MEASUREMENT_PROFILE', $('.js-checkout-measurement-profile.selectized').val());
        $(document).on('change', '.js-checkout-measurement-profile.selectized', function(event) {
            event.preventDefault();
            Cookies.set('CHECKOUT_SELECTED_MEASUREMENT_PROFILE', $(this).val());

            // check checkout checklist and enable/disable 'complete order' button
            checkout.checkChecklistAndButton();

        });

    }







    /*-----------------------------------------------------*\
        Detect when someone tries to checkout by clicking
    \*-----------------------------------------------------*/
    window.checkoutAttemptedByClicking = false
    $('.checkout__order-btn').click(function(){
        window.checkoutAttemptedByClicking = true
    })






    /*------------------------------------*\
        Promo Code Adding & Validation
    \*------------------------------------*/
    $('[js-promo-code-form]').on('submit', function(event) {
        event.preventDefault();


        var promo_code_val = ( $(this).find('[js-promo-code-input]').val() ).toUpperCase();
        Cookies.set('CHECKOUT_PROMO_CODE', promo_code_val);

        var $btn = $(this).find('[js-promo-code-btn]');

        if (promo_code_val) {

            $btn.text('Adding...');

            checkout.afterAnyActionThatTriggersCalculate();

            // check checkout checklist and enable/disable 'complete order' button
            checkout.checkChecklistAndButton();

            checkout.calculateAndRenderPrices({
                success: function(jqXHR){
                    $btn.text('Added');

                    // check checkout checklist and enable/disable 'complete order' button
                    checkout.checkChecklistAndButton();

                },
                error: function(jqXHR){
                    $btn.text('Retry');
                    Cookies.remove('CHECKOUT_PROMO_CODE');
                    $('[js-promo-code-btn]').prop('disabled', false);
                    $('[js-promo-code-btn]').removeClass('is-disabled');
                    $('[js-promo-code-input]').prop('disabled', false);
                    $('[js-promo-code-input]').removeClass('is-disabled');

                    // check checkout checklist and enable/disable 'complete order' button
                    checkout.checkChecklistAndButton();

                },
            });

        }
    });







    /*------------------------------------*\
        Refcode Adding & Validation
    \*------------------------------------*/
    $('[js-rsrefcode-form]').on('submit', function(event) {
        event.preventDefault();


        var rsrefcode_val = $(this).find('[js-rsrefcode-input]').val();
        Cookies.set('CHECKOUT_RSREFCODE', rsrefcode_val);

        var $btn = $(this).find('[js-rsrefcode-btn]');

        if (rsrefcode_val) {

            $btn.text('Adding...');

            checkout.afterAnyActionThatTriggersCalculate();

            // check checkout checklist and enable/disable 'complete order' button
            checkout.checkChecklistAndButton();

            checkout.calculateAndRenderPrices({
                success: function(data){
                    if (data.data.ReferralCode) {
                        $btn.text('Added');
                    } else {
                        $btn.text('Retry');
                        Cookies.remove('CHECKOUT_RSREFCODE');
                        $('[js-rsrefcode-input]').val('');
                        $btn.text('ADD');
                        alertify.alert('The referral code which you provided is invalid.');
                    }


                    // check checkout checklist and enable/disable 'complete order' button
                    checkout.checkChecklistAndButton();

                },
                error: function(data){
                    $btn.text('Retry');
                    Cookies.remove('CHECKOUT_RSREFCODE');
                    alertify.alert('There was an error while adding referral code.');

                    // check checkout checklist and enable/disable 'complete order' button
                    checkout.checkChecklistAndButton();
                },
            });

        }
    });










    /*------------------------------------*\
        Change Shipping Method
    \*------------------------------------*/
    Cookies.set('CHECKOUT_SHIPPING_METHOD', 'SHIP1'); // set default to SHIP1
    $(document).on('change', '[js-checkout-page-container] input[type="radio"][name="shipping_method"]', function(event) {
        Cookies.set('CHECKOUT_SHIPPING_METHOD', $(this).val());
        checkout.calculate('changed shipping method');

        // check checkout checklist and enable/disable 'complete order' button
        checkout.checkChecklistAndButton();
    });







    /*------------------------------------*\
        Initial Check
    \*------------------------------------*/

    /*
    // timeout hax
    setTimeout(function() {

        // check checkout checklist and enable/disable 'complete order' button
        checkout.checkChecklistAndButton();

        // [js-checkout-page-container] input[name="ZipCode"]

    }.bind(this), 1000);
    */




    /*------------------------------------*\
        calculate on  zipcode change
    \*------------------------------------*/

    $(document).on('change', '[js-checkout-page-container] input[name="ZipCode"]', function(event) {

        if ($(this).val() && !!window.addedLocalProductsToBackendCart) {
            checkout.calculate('changed zip code');
        }

        // check checkout checklist and enable/disable 'complete order' button
        checkout.checkChecklistAndButton();

    });






    /*------------------------------------*\
        calculate on state change
        only if zip code is present
    \*------------------------------------*/

    $(document).on('change', '[js-checkout-page-container] select[name="State"]', function(event) {
        var postalZip = $('[js-checkout-page-container] input[name="ZipCode"]').val();
        if (postalZip && $(this).val() && !!window.addedLocalProductsToBackendCart) {
            checkout.calculate('state changed');
        }
        // check checkout checklist and enable/disable 'complete order' button
        checkout.checkChecklistAndButton();
    });



    /*------------------------------------*\
        calculate on country change
        only if zip code is present
    \*------------------------------------*/

    $(document).on('change', '[js-checkout-page-container] select[name="Country"]', function(event) {
        var postalZip = $('[js-checkout-page-container] input[name="ZipCode"]').val();
        if (postalZip && $(this).val() && !!window.addedLocalProductsToBackendCart) {
            checkout.calculate('country changed');
        }
        // check checkout checklist and enable/disable 'complete order' button
        checkout.checkChecklistAndButton();
    });





    /*------------------------------------*\
        calculate on address change
    \*------------------------------------*/
    $(document).on('change', '.j.js-home-address-form select', function(event) {

        if (!checkout.checklist.homeAddressValidated) {
            $('[js-checkout-shipping-address-btn]').show();
        }

    });





    /*------------------------------------*\
        shipping address input
    \*------------------------------------*/
    /*
    $('[js-checkout-shipping-address-btn]').hide();
    $(document).on('input', '.js-home-address-form input, .js-home-address-form textarea', function(event) {

        if (!checkout.checklist.homeAddressValidated) {
            $('[js-checkout-shipping-address-btn]').show();
        }

    });
    */





    /*------------------------------------*\
        lsCart new item event
    \*------------------------------------*/
    $(window).on('lscart-newitem', function(event, data) {

        if ($('[js-checkout-page]').length && !!window.addedLocalProductsToBackendCart) {
            // checkout.calculate('added new cart item');
            console.log('Not calculating.. SKIPPING');
        }

        // check checkout checklist and enable/disable 'complete order' button
        checkout.checkChecklistAndButton();

    });





    /*------------------------------------*\
        removed from cart event
    \*------------------------------------*/

    $(window).on('checkout-cartitemremoved', function(){

        checkout.addLocalProductsToBackendCart(() => checkout.calculate('cart item removed'))

        // check checkout checklist and enable/disable 'complete order' button
        checkout.checkChecklistAndButton();
    });











    /*------------------------------------*\
        Add Rsrefcode if present
    \*------------------------------------*/
    var $checkoutContainer = $('[js-page-checkout-container]');

    if ($checkoutContainer.find('input[name="rsrefcode"]').val()) {
        $('[js-rsrefcode-form]').trigger('submit');
    }



    /*------------------------------------*\
        Cart sidebar btn click checks
    \*------------------------------------*/

    $checkoutContainer.on('submit', function(event) {

        // check checkout checklist and enable/disable 'complete order' button
        checkout.checkChecklistAndButton();

        event.preventDefault();
    });





    /*--------------------------------------------------------*\
        Retry Address
    \*--------------------------------------------------------*/
    $(document).on('click', '[js-checkout-shipping-address-btn]', function(event){

        // check checkout checklist and enable/disable 'complete order' button
        checkout.checkChecklistAndButton();

        checkout.calculate('retry address');
    });



    /*--------------------------------------------------------*\
        Make Order
    \*--------------------------------------------------------*/
    var makeFinalOrder = function(context){

        if (!checkout.checklistCompleted()) { return false; }

        console.warn('makeFinalOrder with context: ' + context);
        checkout.checklist.checkoutNotPerformedYet = false;

        var btn = $('[js-checkout-page-checkout-btn]');


        // btn...
        $(btn).text('Processing Order...');
        $(btn).addClass('is-disabled');
        $(btn).prop('disabled', true);



        pageEl.find('[js-checkout-order-callback]')
        .text('...')
        .removeClass('is-visible')
        .removeClass('is-error')
        .removeClass('is-success');


        pageEl.find('.checkout__loader').hide();
        pageEl.find('.checkout__subtotals').hide();
        pageEl.find('.checkout__total').hide();


        checkout.addLocalProductsToBackendCart(function(){


            // INITIAL REQUEST DATA

            var requestData = {
                'special_instructions': '',
                'shipping_method': Cookies.get('CHECKOUT_SHIPPING_METHOD') ? Cookies.get('CHECKOUT_SHIPPING_METHOD') : 'SHIP1',
                'ephCountry': ephGlobals.country,
            };





            // REFERRAL CODE

            // check if it already has referral code referred value
            if ( pageEl.find('[js-rsrefcode-isreferred-value]').val() ) {
                // and do nothing
            }

            // if not check if user manually entered referral code
            else if ( pageEl.find('input[name="rsrefcode"]').val() ) {
                requestData.rsrefcode = pageEl.find('input[name="rsrefcode"]').val();
            }

            // if not then check if it's in cookies
            else if (Cookies.get('CHECKOUT_RSREFCODE')) {
                requestData.rsrefcode = Cookies.get('CHECKOUT_RSREFCODE');
            }







            // PROMO CODE

            if (Cookies.get('CHECKOUT_PROMO_CODE')) {
                requestData.promo_code = ( Cookies.get('CHECKOUT_PROMO_CODE') ).toUpperCase();
            }





            // ADDRESS
            var AddressLine1 = pageEl.find('input[name="AddressLine1"]').val();
            var AddressLine2 = '';
            var City = pageEl.find('input[name="City"]').val();
            var Country = pageEl.find('select[name="Country"]').val();
            var State = pageEl.find('select[name="State"]').val();
            var ZipCode = pageEl.find('input[name="ZipCode"]').val();

            AddressLine1 ? (requestData.AddressLine1 = AddressLine1) : null;
            AddressLine2 ? (requestData.AddressLine2 = AddressLine2) : null;
            City ? (requestData.City = City) : null;
            Country ? (requestData.Country = Country) : null;
            State ? (requestData.State = State) : null;
            ZipCode ? (requestData.ZipCode = ZipCode) : null;





            // MEASUREMENT PROFILE
            var measurementProfile = $('.js-checkout-measurement-profile.selectized').val();




            // SUCCESS

            var success = function(data, textStatus, jqXHR){


                //alertify.alert( String(jqXHR.responseJSON.msg).capitalize() );

                window.ga('send', {
                  hitType: 'event',
                  eventCategory: 'checkout',
                  eventAction: 'complete - order #' + data.data.OrderId,
                  eventLabel: 'Order #' + data.data.OrderId,
                });

                window.fbq('track', "Purchase", {
                    value: data.data.BalanceDue,
                    currency: "CAD",
                    contents: Object.keys(lsCart.getAllItems()).map(function(key) {return lsCart.getAllItems()[key];}),
                    content_type: 'product',
                    num_items: Object.keys(lsCart.getAllItems()).length
                })

                window.ga('ecommerce:addTransaction', {
                  'id': data.data.OrderId,
                  'affiliation': 'EPH ECOMM',
                  'revenue': data.data.BalanceDue,
                  'shipping': data.data.ShippingCost,
                  'tax': data.data.GSTTotal + data.data.PSTTotal + data.data.HSTTotal,
                });

                ga('ecommerce:send');

                $(btn).text('Order made successfully!');
                $(btn).hide();

                /*
                pageEl.find('[js-checkout-order-callback]')
                .text('Order made successfully!')
                .addClass('is-visible')
                .removeClass('is-error')
                .addClass('is-success');
                */


                // check if there was any quick addition (without customizations)

                var quick_add_present = false;
                var items = lsCart.getAllItems();
                for(var key in items){
                    var item = items[key];
                    if (item.quick_add) {
                        quick_add_present = true;
                    }
                }


                var confirmationBody = (quick_add_present ?
                    'When you\'re ready, visit your Eph profile to customize your garment(s).       \
                    We\'ll craft it to your specs and ship you something that\'s                    \
                    uniquely yours a few short weeks after. <br>                                    \
                    Thanks for choosing Eph Apparel - Cheers! <br>                                  \
                    You will now be redirected to your profile.'
                    : 'Your order has now been submitted and will be hand cut to your size and      \
                    specifications in just a few short weeks. <br>                                  \
                    Thanks for choosing Eph Apparel – Cheers! <br>                                  \
                    You will now be redirected to your profile.'
                );

                var confirmationHTML = '                                                            \
                <div class="shame__order-confirm">                                                  \
                    <div class="shame__order-confirm-img">                                          \
                        <img src="'+WP_STATIC_URL+'/img/icon/celebration.png" />                    \
                    </div>                                                                          \
                    <h2 class="shame__order-confirm-title">Your purchase was successful</h2>        \
                    <p class="shame__order-confirm-desc">' + confirmationBody + '</p>               \
                </div>';



                alertify.alert(confirmationHTML, function(){
                    window.location.href = WP_SITEURL + '/profile/?purchase-successful&order=showtab#' + data.data.OrderId;
                });
                alertify.reset();

                $('div.alertify').addClass('is-checkout-message');

                lsCart.removeAll();

                setTimeout(function(){
                    window.location.href = WP_SITEURL + '/profile/?purchase-successful&order=showtab#' + data.data.OrderId;
                }, 6000);


                // btn hackfix...
                $(btn).text('Order Complete...');
                $(btn).addClass('is-disabled');
                $(btn).prop('disabled', true);


            };


            // ERROR

            var error = function(jqXHR, textStatus, errorThrown){

                $(btn).prop('disabled', true);
                $(btn).addClass('is-disabled');
                $(btn).text('Please reload the page to try again.');

                pageEl.find('[js-checkout-order-callback]')
                .text( String(jqXHR.responseJSON.msg).capitalize() )
                .addClass('is-visible')
                .removeClass('is-success')
                .addClass('is-error');


                alertify.alert('Something went wrong while making order... Please reload the page and try again.')


            };



            // COMPLETE

            var complete = function(jqXHR, textStatus){



            };



            // btn hackfix...
            setTimeout(function() {
                $(btn).text('Processing Order...');
                $(btn).addClass('is-disabled');
                $(btn).prop('disabled', true);
            }, 100);


            // MAKE THE CALL

            checkout.checkoutOrder(requestData, measurementProfile, success, error, complete );


        });



        // btn hackfix...
        setTimeout(function() {
            $(btn).text('Processing Order...');
            $(btn).addClass('is-disabled');
            $(btn).prop('disabled', true);
        }, 100);

    };





    /*--------------------------------------------------------*\
        Make The Order Button
    \*--------------------------------------------------------*/
    $('[js-checkout-page-checkout-btn]').on('click', function(event) {


        event.preventDefault();


        if (!checkout.checklistCompleted()) {

            // check checkout checklist and enable/disable 'complete order' button
            checkout.checkChecklistAndButton();

            checkout.showSomeErrors();

            checkout.calculate('make an order');

            return false;
        }



        // validate address
        var addressValidated = $('.js-home-address-form').parsley().validate();
        if ( (!globalCustomerHasSquareCard) && (!addressValidated) ) {
            alertify.alert('Before completing your order you need to make sure that you\'ve filled all the required fields. ');
        }
        if (!addressValidated) {
            return false;
        }




        // do some DOM manipulations...
        $('[js-credit-card-form]').find('.js-form-callback')
        .removeClass('is-visible').removeClass('is-success').removeClass('is-error');





        // if user does have credit card then just make order
        if (window.globalCustomerHasSquareCard) {
            makeFinalOrder('on checkout btn click if the user has square card');
            return false;
        }


    });



    /*--------------------------------------------------------*\
        Run Checklist on square card added
    \*--------------------------------------------------------*/
    $(window).on('ephSquareCardAddedOk', function(event) {
        checkout.checkChecklistAndButton();
    });





    /*--------------------------------------------------------*\
        Initial Check
    \*--------------------------------------------------------*/
    if ($('[js-checkout-page]').length) {

        // check checkout checklist and enable/disable 'complete order' button
        checkout.checkChecklistAndButton();

    }



}; // end of module.exports




// WEBPACK FOOTER //
// ./js-source/integration/checkout-flow.js